import { createReducer } from '@reduxjs/toolkit'
import { types } from 'actions/campaign_postorders/create_postorder_form'

const updateStateBasedResponse = (state, responseData) => {
  const { location_id, items } = responseData
  state.locationId = location_id
  state.items = items
}

const updateItemData = (state, campaignElementId, data) => {
  const itemIndex = state.items.findIndex(item => item.campaignElementId == campaignElementId)
  if (itemIndex !== -1) {
    Object.assign(state.items[itemIndex], data)
  }
}

export default createReducer({}, (builder) => {
  builder
    .addCase(types.INIT, (state, action) => {
      const { campaignId, locationId, locations, items } = action
      Object.assign(state, { campaignId, locationId, locations, items })
    })
    .addCase(types.GET_ITEMS, (state, action) => {
      updateStateBasedResponse(state, action.data)
    })
    .addCase(types.UPDATE_ITEM, (state, action) => {
      updateItemData(state, action.campaignElementId, action.data)
    })
    .addCase(types.CREATE_POSTORDER_WITH_ITEMS, (state) => {
      // No-op case
    })
})
